module.exports = __webpack_public_path__ + "static/media/hero.04720087.jpg";